import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { AS_OF_DATE_LATEST } from 'CustomPDFReportsApp/ts/constants';
import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
import { fetchUserPreferences, setCoverPageInfo, setCoverPageInfoFailure, setUserPreferencesFetchFailure, setUserPreferencesFetchSuccess, } from './cover-page.actions';
export const coverPageInfo = createReducer({
    contactEmail: null,
    contactPhone: null,
    contactUrl: null,
    organization: null,
    preparedBy: null,
    preparedFor: null,
    customField: null,
    asOfDateOption: AS_OF_DATE_LATEST,
    designationType: CustomPDFReportDesignation.DELIVERABLE,
}, on(setCoverPageInfo, (state, { contactEmail, contactPhone, contactUrl, organization, preparedBy, preparedFor, customField, asOfDateOption, designationType, }) => {
    return {
        contactEmail,
        contactPhone,
        contactUrl,
        organization,
        preparedBy,
        preparedFor,
        customField,
        asOfDateOption,
        designationType,
    };
}), on(resetAllCustomPdfReportItems, () => {
    return {
        contactEmail: null,
        contactPhone: null,
        contactUrl: null,
        organization: null,
        preparedBy: null,
        preparedFor: null,
        customField: null,
        asOfDateOption: AS_OF_DATE_LATEST,
        designationType: CustomPDFReportDesignation.DELIVERABLE,
    };
}), on(setUserPreferencesFetchSuccess, (state, { contactEmail, contactPhone, contactUrl, organization, preparedBy, reportDesignation }) => {
    return { ...state, contactEmail, contactPhone, contactUrl, organization, preparedBy, reportDesignation };
}));
export const userPreferenceFetchRequest = createReducer({ fetching: false, error: false }, on(fetchUserPreferences, () => {
    return { fetching: true, error: false };
}), on(setUserPreferencesFetchSuccess, () => {
    return { fetching: false, error: false };
}), on(setUserPreferencesFetchFailure, setCoverPageInfoFailure, () => {
    return { fetching: false, error: true };
}), on(resetAllCustomPdfReportItems, () => {
    return { fetching: false, error: false };
}));
